import { Command } from 'commander'

import { DeleteSchemaCommand } from '@/domains/schema/delete'
import { ListSchemaCommand } from '@/domains/schema/list'
import { PublishSchemaCommand } from '@/domains/schema/publish'
import { UpdateSchemaCommand } from '@/domains/schema/update'

const schemaCommands = [
  DeleteSchemaCommand,
  UpdateSchemaCommand,
  ListSchemaCommand,
  PublishSchemaCommand,
]

const schemaDomain = new Command('schema')

schemaDomain.description('Manage your Scalar schemas')
schemaCommands.forEach((command) => schemaDomain.addCommand(command()))

export default schemaDomain
